import React, { useContext } from "react";
import { compose } from "redux";
import { connect } from "react-redux";

// core components
import OutOfOfficeContainer from "./outOfOffice/OutOfOfficeContainer";
import UserInfoContainer from "features/userProfile/userInfo/components/UserInfoContainer";
import UserAgendaContainer from "features/userProfile/userAgenda/UserAgendaContainer";
import HeaderPortal from "../layout/HeaderPortal";
import UserRightsListContainer from "features/userProfile/userRights/list/components/UserRightsListContainer";
import UserGroupsContainer from "features/userProfile/userGroups/components/UserGroupsContainer";
import { GlobalRightsContext } from "providers/GlobalRightsContext";

const UserContainer = () => {
  const { myProfileSecurityDataRead } = useContext(GlobalRightsContext);
  return (
    <React.Fragment>
      <OutOfOfficeContainer></OutOfOfficeContainer>
      <UserInfoContainer></UserInfoContainer>
      {myProfileSecurityDataRead && <UserGroupsContainer />}
      {myProfileSecurityDataRead && <UserRightsListContainer />}
      <UserAgendaContainer />
      <HeaderPortal />
    </React.Fragment>
  );
};

UserContainer.propTypes = {};

export default compose(connect(null, null))(UserContainer);
